import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import * as XLSX from 'xlsx'
import Loader from 'react-js-loader'
import Swal from 'sweetalert2'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { apiRequest } from '../../store/allApi'

import { dateFormat } from '../../utils/dateTime'
const SucWithdraw = () => {
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState()
      const [userExport, setExport] = useState()
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);
    const [startDate, setStartDate] = useState(null)
        const [endDate, setEndDate] = useState(null);
        const baseUrl = process.env.REACT_APP_API_BASE_URL;


  let [limit, setLimit] = useState(10)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState("Phone")
  const [findByStatus, setFindByStatus] = useState(0)

  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value
    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    setSearchType("0")
    let key = event.target.value
    setFindByStatus(key)
  }

  const profle =async () => {
    // setLoading(true)
    // Swal.showLoading(Swal.getDenyButton())
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
 
     try {
          const res = await apiRequest(`admin/txn/withdraw_admin/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&date=${startDate}&end=${endDate}`,"GET", null,headers)
         if (res.data) {
             setUser(res.data.data)
        setNumberOfPages(res.data.totalPages)
        // Swal.hideLoading( {timer: 1500})
        // setLoading(false)
         }
            } catch (e) {
             console.log(e)
            }
            finally {
            }
  }

  const profleExport =async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
   
     try {
          const res = await apiRequest(`admin/txn/withdraw_admin/all`,"GET", null,headers)
         if (res.data) {
          setExport(res.data.data)
         }
            } catch (e) {
              setLoading(false);
            }
            finally {
            }
  }

  const [withdrawSuccess, setWithdrawSuccess] = useState()
  const [withdrawFail, setWithdrawFail] = useState()

 


  const universalCheckPayout = (payment_gatway, txn_id, referenceId, userID) => {
    //alert(payment_gatway);
    if (!referenceId) {
      alert('Payout txn id not found')
    }
    // if(payment_gatway == 'KVMPAY'){
    //   checkkvmPayPayment(txn_id,referenceId)
    // }  else {
    //   alert('Nothing found')
    // }
  }


  const checkkvmPayPayment = (txn_id,referenceId) => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      axios
        .post(
          baseUrl + `kvmpay-payout-status`,
          { txn_id,referenceId :txn_id},
          { headers }
        )
      .then(res => {
    setLoading(false)
    Swal.fire({
      title: res.data.status === 'success'  ? 'Success' : 'Error',
      text: res.data.message,
      icon: res.data.status === 'success' ? 'success' : 'error' // Changed 'danger' to 'error'
    });
        profle()
      })
      .catch(e => {
    setLoading(false)
        if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');
          window.location.reload()
        }
      })
  }

  function daterange (s, e) {
    if (s > e) {
      alert("Starting date is greater than ending date");
    } else {
      setStartDate(s);
      setEndDate(e);
    }
  console.log(s,e)
    // Change start date format
    var startDate = new Date(s);
    var startDay = startDate.getDate();
    var startMonth = startDate.getMonth() + 1; // Months are zero-based
    var startYear = startDate.getFullYear();
    var startHours = startDate.getHours();
    var startMinutes = startDate.getMinutes();
    var startSeconds = startDate.getSeconds();
  
    // Change end date format
    var endDate = new Date(e);
    var endDay = endDate.getDate();
    var endMonth = endDate.getMonth() + 1; // Months are zero-based
    var endYear = endDate.getFullYear();
    var endHours = endDate.getHours();
    var endMinutes = endDate.getMinutes();
    var endSeconds = endDate.getSeconds();
  
  
  }

const imageopen = (image) => {
    Swal.fire({
      title: "Pay Qr Code",
      text: "",
      imageUrl: baseUrl+image,
      imageWidth: 400,
      imageHeight: 300,
      imageAlt: "Custom image"
    })
  }


   // excel data downlord
        const createDownloadData = () => {
          handleExport()
        }
        const handleExport = () => {
          let table1 = [
            {
              A: 'Name',
              B: 'Withdraw Amount',
              C: 'Withdraw Status'
            }
          ]
      
          userExport.forEach(row => {
            const userDetails = row
            console.log('exldata', userDetails)
            table1.push({
              A: userDetails.User_id ? userDetails.User_id.Name : '',
              B: userDetails.amount ? userDetails.amount : '',
              C: userDetails.status ? userDetails.status : ''
            })
          })
      
          //table1 = [{A:"User Details"}].concat(table1);
          //const finalData = [...table1];
          //console.log(finalData);
          /* convert state to workbook */
          const ws = XLSX.utils.json_to_sheet(table1, {
            skipHeader: true
          })
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'SheetJS')
          /* generate XLSX file and send to client */
          XLSX.writeFile(wb, 'WithdrawReport.xlsx')
        }


  useEffect(() => {
    profle()
    const interval = setInterval(() => {
      profle()
    }, 4000)
    return () => clearInterval(interval)
    profleExport()
  }, [pageNumber, limit, searchList, searchType, findByStatus, startDate, endDate])

  if (user == undefined) {
    return null
  }
  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={'Loading Please Wait'}
            color={'#FFFFFF'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body text-light table_bg'>
              <h4 className=' dashboard_heading'>withdrawal History</h4>
              <div>
            {userData.user_type == 'Admin' ? (
              <button
                    onClick={() => {
                      createDownloadData()
                    }}
                    className='btn btn-primary mr-2'
                  >
                    Export Data
                  </button>
                   ) : (
                    ""
                   )}
              </div>
              <select
                className='form-control col-sm-1 m-1 bg-dark text-light'
                id='pagelimit'
                name='pagelimit'
                onChange={setpageLimit}
              >
                <option value='10'>Set limit</option>
                <option value='20'>20</option>
                <option value='50'>50</option>
                <option value='100'>100</option>
                <option value='500'>500</option>
              </select>

              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                  <option value='0'>Select Search by</option>
                  <option value='Phone'>Phone</option>
                  <option value='_id'>Transaction Id</option>
                  <option value='account_number'>Account Number</option>
                  <option value='upi_id'>UPI ID</option>
                  <option value='amount'>Amount</option>
                  <option value='adminId'>Admin/Agent</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
                <h5>Or</h5>
                <select
                  className='form-control col-sm-3 m-2'
                  id='findByStatus'
                  name='findByStatus'
                  onChange={searchByStatus}
                >
                  <option value='0'>Search Status</option>
                  <option value='SUCCESS'>Success</option>
                  <option value='Pending'>Pending</option>
                  <option value='pending'>pending</option>
                  <option value='none'>Proccessing</option>
                  <option value='REJECT'>Reject</option>
                  <option value='FAILED'>Failed</option>
                </select>
              </div>
              <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={startDate}   onChange={(e) => daterange(e.target.value, endDate)}
              required
            />
            to
                <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={endDate}   onChange={(e) => daterange(startDate,e.target.value)}
              required
            />

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> ID</th>
                      <th> Phone</th>
                      <th> User</th>
                      <th> type</th>
                      <th> txn-msg</th>
                      <th>UPI ID</th>
                      {/* <th>Order ID</th> */}
                      <th> Amount </th>
                      <th> Qr Code </th>
                      <th> Status </th>
                      <th> Verify By </th>
                      <th> Approve By </th>
                      <th> Request Time </th>
                      <th> Admin Approve Time </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        const approveAt =
                          data.withdrawVerifiedAt ||
                          (data.withdrawVerified ? data.updatedAt : null)
                        return (
                          <tr>
                            <td>{key + 1}</td>
                            <td>{data._id}</td>
                            {userData.user_type == 'Admin'   ? (
                          <td>{data.User_id?.Phone}</td>
                        ) : (
                          <td>{`${
                            '********' + data.User_id?.Phone.toString().slice(-2)
                          }`}</td>
                        )}

                            <td>
                              {data.User_id && (
                                <Link
                                  className='btn btn-sm btn-outline-info'
                                  to={`/user/view_user/${data.User_id._id}`}
                                >
                                      {
                                  data.User_id?.Red_zone == true ?
                                <span className="text-danger">
                                {data.User_id.Name}
                                </span>
                                :
                                <span>
                                {data.User_id.Name}
                                </span>
}
                                </Link>
                              )}
                            </td>
                            <td>
                              <span className='pl-2'>{data.Withdraw_type}</span>
                            </td>
                            <td>
                              <span className='pl-2'>
                                {data.txn_msg}
                              </span>
                            </td>
                            <td>
                              <span className='pl-2'>
                                {data.bankDetail.upiId}
                              </span>
                            </td>
                            {/* <td>
                              <span className='pl-2'>
                                {data.order_id}
                              </span>
                            </td> */}
                            <td>{data.amount}</td>
                            <td>
      <img
        src={`${baseUrl}${data?.paymentImage}`}
        onClick={() => imageopen(data?.paymentImage)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/error.png";
        }}
      // Adjust the width as needed
      />

     
    </td>
                            <td className='font-weight-bold text-success'>
                              {data.status === 'none'
                                ? 'Proccessing'
                                : data.status}
                            </td>
                           
                            <td className='font-weight-bold '>
                              {data?.withdrawVerified_by?.Name}
                            </td>
                            <td className='font-weight-bold '>
                              {data?.action_by?.Name}
                            </td>
                            <td>{dateFormat(data.createdAt)}</td>
                            <td>
                              {approveAt ? dateFormat(approveAt) : '—'}
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SucWithdraw
